function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgItunesLogoinline = function SvgItunesLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 22",
    style: {
      enableBackground: "new 0 0 23 22"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.36)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ItunesLogo_inline_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: -904.997,
    y1: 527.033,
    x2: -905.356,
    y2: 527.967,
    gradientTransform: "matrix(22.21 0 0 -22 20115.074 11616)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22c9fd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    style: {
      stopColor: "#4996fe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    style: {
      stopColor: "#6b6bff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    style: {
      stopColor: "#9b5de0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    style: {
      stopColor: "#c950c3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    style: {
      stopColor: "#da4bb8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    style: {
      stopColor: "#de4dae"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    style: {
      stopColor: "#ec5485"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    style: {
      stopColor: "#f65968"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    style: {
      stopColor: "#fd5c56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff5d50"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1,
    cy: 11,
    rx: 11.1,
    ry: 11,
    style: {
      fill: "url(#ItunesLogo_inline_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ItunesLogo_inline_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: -901.275,
    y1: 524.807,
    x2: -901.275,
    y2: 525.807,
    gradientTransform: "matrix(20.35 0 0 -20.158 18352.057 10600.089)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dde2e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    style: {
      stopColor: "#e5e8ec"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#f7f7f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fdfcfd"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1,
    cy: 11,
    rx: 10.2,
    ry: 10.1,
    style: {
      fill: "url(#ItunesLogo_inline_svg__b)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ItunesLogo_inline_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: -861.883,
    y1: 513.378,
    x2: -862.526,
    y2: 514.128,
    gradientTransform: "matrix(11.1201 0 0 -13.998 9599.285 7202.59)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#22c9fd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.049,
    style: {
      stopColor: "#2abefd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    style: {
      stopColor: "#6b6bff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    style: {
      stopColor: "#756af3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    style: {
      stopColor: "#8d68d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#b864a4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    style: {
      stopColor: "#d56182"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    style: {
      stopColor: "#ec5f67"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#fa5d56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff5d50"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.3c0-.4-.2-.6-.6-.6 0 0-6 1.2-6.7 1.3-.4.1-.6.4-.6.9v7.7c0 .8-.7.6-1.5.8-1.5.4-1.5 1-1.6 1.2-.2.8 0 1.7 1.2 2 .5.1.8.1 1.2 0 .7-.1 1.1-.5 1.4-1.2.2-.3.2-.9.2-1.2V8.8c0-.4.1-.5.5-.6 1.8-.3 3.6-.7 5.4-1.1.4-.1.4.1.4.5v4.6c0 .9-1.8.4-2.9 1.4-.4.4-.5 1.1-.3 1.5.2.6.6 1 1.2 1.1.4.1 1.6.2 2.4-.7.5-.6.5-1 .5-1.5-.2 0-.2-9.7-.2-9.7z",
    style: {
      fill: "url(#ItunesLogo_inline_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ItunesLogo_inline_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: -900.913,
    y1: 524.807,
    x2: -900.913,
    y2: 525.807,
    gradientTransform: "matrix(20.349 0 0 -20.158 18344.14 10600.088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#dde2e7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    style: {
      stopColor: "#e5e8ec"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#f7f7f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fdfcfd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.5.9C5.8.9 1.3 5.4 1.3 11c0 5.5 4.5 10 10.2 10s10.1-4.5 10.1-10C21.6 5.4 17.1.9 11.5.9zm4.6 14.7c-.7.9-2 .8-2.4.7-.6-.1-1-.5-1.2-1.1-.1-.4-.1-1.1.3-1.5 1.1-1 2.9-.5 2.9-1.4V7.7c0-.4 0-.6-.4-.5-1.8.3-3.6.7-5.4 1.1-.3 0-.4.1-.4.5v6.5c0 .3 0 .9-.2 1.2-.3.7-.7 1-1.4 1.2-.5.1-.8.1-1.2 0-1.1-.3-1.3-1.2-1.2-2 0 0 .1-.2.1-.3.3-.5.5-.6 1.5-1 .9-.3 1.5 0 1.5-.8V5.9c0-.5.1-.8.6-.8.7-.1 6.7-1.3 6.7-1.3.4-.1.6.2.6.6v9.8c0 .4.1.8-.4 1.4z",
    style: {
      fill: "url(#ItunesLogo_inline_svg__d)"
    }
  }));
};
export default SvgItunesLogoinline;